import { createAction, props } from "@ngrx/store";
import { RequirementOverrideDetail } from "../../models/requirement-override-detail.model";
import { DocumentTypeLevelType } from "../../models/requirement-descriptions.model";

export const loadRequirementOverrideDetails = createAction(
    '[REQUIREMENT OVERRIDE] Load Requirement Override Details',
    props<{ documentTypeId: number, entityType: DocumentTypeLevelType, entityId: number }>()
);

export const loadRequirementOverrideDetailsSuccessfully = createAction(
    '[REQUIREMENT OVERRIDE API] Load Requirement Override Details Successfully',
    props<{ details: RequirementOverrideDetail }>()
);

export const loadRequirementOverrideDetailsFailure = createAction(
    '[REQUIREMENT OVERRIDE API] Load Requirement Override Details Failure',
    props<{ error: unknown }>()
);

export const setRequirementOverrideIsLoadingFlag = createAction(
    '[REQUIREMENT OVERRIDE] Set Requirement Override IsLoading Flag',
    props<{
        isLoading: boolean;
    }>()
);